import { render, staticRenderFns } from "./Railway.vue?vue&type=template&id=e604c2da&scoped=true&"
import script from "./Railway.vue?vue&type=script&lang=js&"
export * from "./Railway.vue?vue&type=script&lang=js&"
import style0 from "./Railway.vue?vue&type=style&index=0&id=e604c2da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e604c2da",
  null
  
)

export default component.exports